fragment AttachmentVariationFragment on AttachmentVariation {
    id
    attachment_id

    number
    name
    description
    image_id
    image {
        ...MediaFragment
    }
    net_price
    gross_price
}